import { ProductSlugs } from '../../common/constants';

// Additional integration product names should be added here as needed
export type IntegrationTypes = 'jira';

export type IntegrationProductInfo = {
  displayName: string;
  paragonIntegrationName?: string;
  integrationProductSlug: ProductSlugs;
};

export function getIntegrationProductInfoFromSlug(
  integrationProductSlug: ProductSlugs
): IntegrationProductInfo {
  switch (integrationProductSlug) {
    case ProductSlugs.jiraIntegration:
      return {
        displayName: 'Jira',
        paragonIntegrationName: 'jira',
        integrationProductSlug
      };
    case ProductSlugs.jiraDirectCloudIntegration:
      return {
        displayName: 'Jira Cloud',
        paragonIntegrationName: 'na',
        integrationProductSlug
      };
    case ProductSlugs.jiraOnPremIntegration:
      return {
        displayName: 'Jira Data Center',
        paragonIntegrationName: 'na',
        integrationProductSlug
      };
    case ProductSlugs.customIntegration:
      return {
        displayName: 'Custom Integration',
        integrationProductSlug
      };
    default:
      throw new Error(
        `Unsupported integration product slug ${integrationProductSlug}`
      );
  }
}
